import styles from './first.module.css';
import { useState } from 'react';
import FullSize from '../../components/full-size';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import { getNextLevelUrl, markLevelCompleted } from '../../helper';
import AnswerForm from '../../components/answer-form';
import ErrorBadge from '../../components/error-badge';
import HintBox from '../../components/hint-box';

function First() {
  const LEVEL = 1;
  const navigate = useNavigate();
  const [shake, setShake] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (answer: string) => {
    if (answer.toLowerCase() === 'fel' || answer.toLowerCase() === '9898') {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setError('Lösenordet är fel');
      setShake(true);
    }
  };
  
  return (
    <FullSize bgColor="linear-gradient(#fc00ff, #00dbde)">
      <div className={styles.wrapper}>
        <Header level={LEVEL} color="white" />
        <p className={styles.text}>Skriv in lösenordet</p>
        <ErrorBadge message={error} />
        <AnswerForm 
          type="password"
          onSubmit={handleSubmit}
          shake={shake}
          setShake={setShake}
        />
        <HintBox hintText="Är ni inte läskunniga? Svaret står ju framför era ögon." />
      </div>
    </FullSize>
  );
}

export default First;
